var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHideLightOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 386 233",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeMiterlimit: 1
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-5234,-7859)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2213.1,2216.85)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.753273,0,0,0.776857,7447.4,5559.76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M510.096,249.937C506.064,244.07 409.168,106.662 255.995,106.662C124.56,106.662 7.44,243.281 2.512,249.105C-0.837,253.073 -0.837,258.897 2.512,262.886C7.44,268.71 124.56,405.329 255.995,405.329C387.43,405.329 504.549,268.71 509.477,262.886C512.571,259.217 512.848,253.905 510.096,249.937ZM255.995,383.996C150.63,383.996 50.448,283.516 24.998,255.996C50.406,228.455 150.481,127.996 255.995,127.996C379.28,127.996 466.299,228.327 487.547,255.42C463.013,282.065 362.256,383.996 255.995,383.996Z",
    style: {
      fill: "rgb(49,57,65)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.753273,0,0,0.776857,7447.4,5559.76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.995,170.662C208.934,170.662 170.662,208.934 170.662,255.995C170.662,303.056 208.934,341.328 255.995,341.328C303.056,341.328 341.328,303.056 341.328,255.995C341.328,208.934 303.056,170.662 255.995,170.662ZM255.995,319.996C220.71,319.996 191.995,291.281 191.995,255.996C191.995,220.711 220.71,191.996 255.995,191.996C291.28,191.996 319.995,220.711 319.995,255.996C319.995,291.281 291.28,319.996 255.995,319.996Z",
    style: {
      fill: "rgb(49,57,65)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,2216.2,-2206.35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5262.41,8055.76L5588.49,7869.43",
    style: {
      fill: "none",
      stroke: "rgb(49,57,65)",
      strokeWidth: 25
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideLightOutline);
export default __webpack_public_path__ + "static/media/hide_light_outline.2d9882aaa09fae659909bb7308c380ca.svg";
export { ForwardRef as ReactComponent };